import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import PacoteEntregaModel from "@/models/pacoteEntregaModel";
import pacoteEntregaService from "@/services/pacoteEntregaService";

import ListComponentBase from "../listComponentBase";

@Component
export default class PacoteEntregaListComponent extends ListComponentBase<PacoteEntregaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn(
                "descricao",
                this.$t("__.Crud.pacote_entrega.edit_vue_html.descricao"),
                GridColumnType.String,
            ),
            new GridColumn("altura", this.$t("__.Crud.pacote_entrega.edit_vue_html.altura"), GridColumnType.String),
            new GridColumn("largura", this.$t("__.Crud.pacote_entrega.edit_vue_html.largura"), GridColumnType.String),
            new GridColumn(
                "comprimento",
                this.$t("__.Crud.pacote_entrega.edit_vue_html.comprimento"),
                GridColumnType.String,
            ),
            new GridColumn("peso", this.$t("__.Crud.pacote_entrega.edit_vue_html.peso"), GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(pacoteEntregaService, "pacoteEntrega", "descricao");
    }
}
